import { typography } from '@dixa/lib-shared-tokens';
import { HighlightType } from 'flow-builder/types/node';
import { hexStringToNumber, purple, red } from './colors';
const text = {
    fontSize: 12,
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontWeight: typography.weight.semibold,
    fill: hexStringToNumber(typography.color.primary),
    padding: 8,
};
const highlight = {
    [HighlightType.ERROR]: red['500'],
    [HighlightType.INFO]: purple['500'],
};
export const styles = {
    text,
    highlight,
};
